import { ApiResult } from '@e3dc-react/shell/Types/api'
import { ShopCheckoutSideBarResponse } from '../models'
import { ShopAuthFetchWithResponse } from '../types'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { handleFetchError } from 'src/Libs/api/utils'
/*
 * This endpoint upload a Quantum Pdf contract
 */
export const uploadQntmPdfContract = async (pdf: Blob, shopFetch: ShopAuthFetchWithResponse): Promise<ApiResult<ShopCheckoutSideBarResponse>> => {
  try {
    const formData = new FormData()
    formData.append('file', pdf)

    const response = await shopFetch<ShopCheckoutSideBarResponse>({
      path: `e3dc/quantum/contract/upload`,
      method: 'POST',
      payload: formData,
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<ShopCheckoutSideBarResponse>(response.data, true)
    }

    return new ApiResult<ShopCheckoutSideBarResponse>(null)
  } catch (error) {
    return handleFetchError<ShopCheckoutSideBarResponse>(null)
  }
}

/*
 * This endpoint deletes a Quantum Pdf contract
 */
export const deleteQntmPdfContract = async (shopFetch: ShopAuthFetchWithResponse): Promise<ApiResult<ShopCheckoutSideBarResponse>> => {
  try {
    const response = await shopFetch<ShopCheckoutSideBarResponse>({
      path: `e3dc/quantum/contract/delete`,
      method: 'DELETE',
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<ShopCheckoutSideBarResponse>(response.data, true)
    }

    return new ApiResult<ShopCheckoutSideBarResponse>(null)
  } catch (error) {
    return handleFetchError<ShopCheckoutSideBarResponse>(null)
  }
}

/*
 * This endpoint will return the Uploaded Quantum pdf document.
 */
export const readQntmContract = async (shopFetch: ShopAuthFetchWithResponse): Promise<ApiResult<string>> => {
  try {
    const response = await shopFetch<string>({
      path: `e3dc/quantum/contract/read`,
      method: 'GET',
      responseType: 'arraybuffer',
    })

    if (response.status === StatusCodes.OK) {
      return new ApiResult<string>(response.data, true)
    }

    return new ApiResult<string>(null)
  } catch (error) {
    return handleFetchError<string>(null)
  }
}
